/**
 * 项目默认配置项
 */

export const API_URL = "/api/";
export const API_TIMEOUT = 180 * 1000;
export const TOKEN_KEY = "token";

export default {
  API_URL,
  API_TIMEOUT,
  TOKEN_KEY
};
